import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { type BadgeParams, getBadgeListFn } from './get-badge-list';
import type { Badge } from './types';
import { apiRoutes } from '@/api/api-routes';

export const useGetBadgeList = (
  params: BadgeParams,
  opts?: Omit<UseQueryOptions<Badge[], DefaultQueryError>, 'queryKey'>
) =>
  useQuery<Badge[], DefaultQueryError>({
    queryKey: [apiRoutes.master_data.badge, params],
    queryFn: () => getBadgeListFn(params),
    ...opts,
  });
